import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { Alert, AlertDescription, AlertTitle } from '../ui/alert';
import { AlertTriangle } from 'lucide-react';
import { checkApiHealth } from '../../utils/api-helpers';
const POLL_MS = 5 * 60 * 1000;
/**
 * Slim global banner when `/health` fails (same signal as ApiStatus).
 * Does not block the UI; informs users that some features may not load.
 */
export const DegradedServiceBanner = () => {
    const [degraded, setDegraded] = useState(false);
    const runCheck = useCallback(async () => {
        try {
            const result = await checkApiHealth();
            setDegraded(!result.isHealthy);
        }
        catch {
            setDegraded(true);
        }
    }, []);
    useEffect(() => {
        runCheck();
        const interval = setInterval(runCheck, POLL_MS);
        const onFocus = () => {
            void runCheck();
        };
        window.addEventListener('focus', onFocus);
        return () => {
            clearInterval(interval);
            window.removeEventListener('focus', onFocus);
        };
    }, [runCheck]);
    if (!degraded) {
        return null;
    }
    return (_jsx("div", { className: "sticky top-0 z-[100] border-b border-amber-500/40 bg-amber-500/15 px-3 py-2 text-sm text-amber-950 dark:text-amber-100", role: "status", "aria-live": "polite", children: _jsxs(Alert, { className: "border-0 bg-transparent p-0 shadow-none", children: [_jsx(AlertTriangle, { className: "h-4 w-4 text-amber-600 dark:text-amber-400", "aria-hidden": true }), _jsx(AlertTitle, { className: "mb-0 text-sm font-semibold", children: "Connection issue" }), _jsx(AlertDescription, { className: "text-sm opacity-90", children: "We're having trouble connecting to our servers. Some features may not load. Please try again in a moment." })] }) }));
};
